import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { FiArrowLeft, FiSend } from 'react-icons/fi';
import { communityAPI } from '../../service/api';
import { showError, showSuccess } from '../../service/swal';

export default function CommunityForm() {
  const navigate = useNavigate();
  const [titre, setTitre] = useState('');
  const [contenu, setContenu] = useState('');
  const [tags, setTags] = useState('');
  const [sending, setSending] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!titre.trim() || !contenu.trim()) {
      showError('Erreur', 'Le titre et le contenu sont obligatoires');
      return;
    }
    setSending(true);
    try {
      const res = await communityAPI.create({
        titre: titre.trim(),
        contenu: contenu.trim(),
        tags: tags.trim() || undefined,
      });
      showSuccess('Publication créée avec succès');
      navigate(`/communautes/${res.data.data.id}`);
    } catch (err) {
      showError('Erreur', 'Impossible de créer la publication');
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="page-container py-8">
      <Link
        to="/communautes"
        className="inline-flex items-center gap-2 text-sm font-medium mb-6"
        style={{ color: '#88929B' }}
      >
        <FiArrowLeft className="w-4 h-4" />
        Retour à la communauté
      </Link>

      <div className="card-root p-6 md:p-8 max-w-2xl">
        <h1 className="font-serif text-2xl font-bold mb-6" style={{ color: '#0A192F' }}>
          Nouvelle publication
        </h1>

        <form onSubmit={handleSubmit} className="space-y-5">
          <div>
            <label className="block text-sm font-medium mb-1.5" style={{ color: '#0A192F' }}>
              Titre *
            </label>
            <input
              type="text"
              value={titre}
              onChange={(e) => setTitre(e.target.value)}
              placeholder="Donnez un titre à votre publication"
              className="w-full px-3 py-2.5 text-sm border"
              style={{ borderColor: '#E2E2E0', color: '#0A192F', borderRadius: 0 }}
              maxLength={200}
              required
            />
          </div>

          <div>
            <label className="block text-sm font-medium mb-1.5" style={{ color: '#0A192F' }}>
              Contenu *
            </label>
            <textarea
              value={contenu}
              onChange={(e) => setContenu(e.target.value)}
              placeholder="Partagez votre expérience, posez une question..."
              rows={8}
              className="w-full px-3 py-2.5 text-sm border"
              style={{ borderColor: '#E2E2E0', color: '#0A192F', borderRadius: 0, resize: 'vertical' }}
              required
            />
          </div>

          <div>
            <label className="block text-sm font-medium mb-1.5" style={{ color: '#0A192F' }}>
              Tags
              <span className="ml-1 text-xs" style={{ color: '#88929B' }}>(optionnel, séparés par des virgules)</span>
            </label>
            <input
              type="text"
              value={tags}
              onChange={(e) => setTags(e.target.value)}
              placeholder="Ex: logement, visa, conseils"
              className="w-full px-3 py-2.5 text-sm border"
              style={{ borderColor: '#E2E2E0', color: '#0A192F', borderRadius: 0 }}
            />
          </div>

          <button
            type="submit"
            disabled={sending}
            className="inline-flex items-center gap-2 px-6 py-3 text-sm font-bold tracking-wider uppercase"
            style={{
              backgroundColor: '#C59B6C',
              color: '#0A192F',
              borderRadius: 0,
              opacity: sending ? 0.6 : 1,
            }}
          >
            <FiSend className="w-4 h-4" />
            {sending ? 'Publication...' : 'Publier'}
          </button>
        </form>
      </div>
    </div>
  );
}
